export const NR_5G_NETMODE: Array<string> = [
    "NR SA", "LTE-NR DC", "NR5G-SA"
];